// extracted by mini-css-extract-plugin
export default {"statusAction":"UserFormLayout_statusAction__TF+vK","formExtraActions":"UserFormLayout_formExtraActions__1c7mC","modalContent":"UserFormLayout_modalContent__z3s8I"};